module.exports = __webpack_public_path__ + "static/media/Bipolar.2c54c18a.svg";